var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "currency-switcher-card",
      attrs: {
        disabled: _vm.isSelected || _vm.currencyRatePending || _vm.backEndError,
      },
      on: { click: _vm.currencySelected },
    },
    [
      false ? _c("div", { staticClass: "currency-flag" }) : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "currency-details" },
        [
          _c("span", {
            staticClass: "currency-iso",
            domProps: {
              innerHTML: _vm._s(
                _vm.item.Symbol +
                  " " +
                  (_vm.parsedCurrencyIso
                    ? _vm.parsedCurrencyIso
                    : _vm.item.IsoCode)
              ),
            },
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "currency-name",
            domProps: {
              innerHTML: _vm._s(
                _vm.parsedName ? _vm.parsedName : _vm.item.Name
              ),
            },
          }),
          _vm._v(" "),
          _vm.isSelecting && _vm.currencyRatePending
            ? _c("loading-dots")
            : _vm._e(),
          _vm._v(" "),
          _c("hr", {
            staticClass: "separator",
            attrs: { "aria-hidden": "true" },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }